// extracted by mini-css-extract-plugin
export default {"messageBox":"ChatIntroLine_messageBox__c9oY3","inList":"ChatIntroLine_inList__g47Fc","addIntro":"ChatIntroLine_addIntro__+Z10-"};